var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.satisfaction)?_c('span',{staticClass:"tag",class:_vm.satisfaction.className},[_c('b',[_vm._v(_vm._s(_vm.$t(`satisfaction.${_vm.satisfaction.status}`)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }